import React, { useContext, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { Container, Table, Button, Row, Col } from 'react-bootstrap'
import { getNames, deleteName } from '../actions/nameActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import PaginateName from '../components/PaginateName'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { ThemeContext } from '../components/ThemeContext.js'
import {
  EMPLOYEE_PERMISSIONS,
  hasEmployeePermission
} from '../constants/employeePermissions.js'

const ListManufacturers = ({ match }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { theme } = useContext(ThemeContext)

  const { pageNumbername } = useParams() || 1
  const { keyword } = useParams()

  const nameList = useSelector((state) => state.nameList)
  const { loading, error, manufacturer, count, pagesname, pagename } = nameList

  const nameDelete = useSelector((state) => state.nameDelete)
  const { success: successDelete } = nameDelete

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const isAuthenticated = Boolean(ownerInfo || userInfo)
  const canManageCatalog = hasEmployeePermission(
    userInfo,
    ownerInfo,
    EMPLOYEE_PERMISSIONS.CATALOG_MANAGE
  )

  const delName = (id) => {
    if (window.confirm('Are you sure?')) {
      dispatch(deleteName(id))
      dispatch({ type: 'NAME_DELETE_RESET' })
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getNames(pageNumbername, keyword))
    } else {
      dispatch({ type: 'NAME_LIST_RESET' })
      navigate('/login')
    }
  }, [
    dispatch,
    navigate,
    keyword,
    pageNumbername,
    isAuthenticated,
    userInfo,
    successDelete
  ])

  return (
    <Container className='catalog-list-page' style={{ color: theme.text }}>
      <Row className='align-items-end inventory-list-heading'>
        <Col>
          <h1 className='mb-1'>Manufacturers</h1>
          <p className='mb-0 inventory-list-subtitle'>
            Suppliers and makers in your catalog.
          </p>
        </Col>
        <Col xs='auto'>
          <span className='inventory-list-count'>
            {Number(count ?? 0).toLocaleString('en-US')} records
          </span>
        </Col>
      </Row>
      <Row className='align-items-center inventory-list-toolbar'>
        <Col>
          <PaginateName pagesname={pagesname} pagename={pagename} />
        </Col>
        {canManageCatalog && (
          <>
            <Col className='text-right'>
              <LinkContainer to='/settings'>
                <Button variant='primary' size='sm' className='my-2'>
                  Add a manufacturer
                </Button>
              </LinkContainer>
            </Col>
          </>
        )}
      </Row>

      {count === 0 && <Message variant='info'>None Found</Message>}
      {loading ?
        <Loader />
      : error ?
        <Message variant='danger'>{error}</Message>
      : <Table
          striped
          bordered
          hover
          responsive
          className='table-sm catalog-list-table'
        >
          <thead>
            <tr>
              <th>Manufacturer</th>
              {canManageCatalog && (
                <th className='catalog-action-heading'>Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {manufacturer.map((name) => (
              <tr key={name._id}>
                <td>{name.manufacturer}</td>
                {canManageCatalog && (
                  <>
                    <td className='catalog-action-cell'>
                      <Button
                        variant='danger'
                        size='sm'
                        onClick={() => delName(name._id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      }
    </Container>
  )
}

export default ListManufacturers
